import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_BASE_URL_KEY, SECURE_AUTH_TOKEN_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteAddBrick } from "../../../data/usecases/brick-management/remote-add-brick";
import { AddBrick } from "../../../domain/useages/brick-management/add-brick";
import Swal from "sweetalert2";
import { BrickManagementStore } from "../../main/BrickManagementStore";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface AddBrickInterface {
  addBrick: Function;
  addBrickState: FetchState;
}

const initialState = {
  addBrickState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddBrickSlice: StateCreator<AddBrickInterface> = (
  set,
  get
) => ({
  ...initialState,
  addBrick: async (payload: AddBrick.Params) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    set({ addBrickState: FetchState.LOADING });

    const remoteAddBrick: AddBrick = new RemoteAddBrick(
      `${BASE_URL}${Endpoints.ADD_BRICK}`,
      axiosHttpClient
    );
    let result = await remoteAddBrick.add(payload);
    if (result.success === true) {
      set({ addBrickState: FetchState.SUCCESS });
      BrickManagementStore.getState().fetchBrickManagement(
        BrickManagementStore.getState().brickManagementFilter
      );
      return result;
    } else {
      set({ addBrickState: FetchState.SUCCESS });
    }
  },
});
